import React, { useState, useEffect } from 'react';

const TestimonialCarousel = () => {
  const testimonials = [
    {
      id: 1,
      text: 'Zentak Solutions transformed our vision into a stunning glassmorphic interface. Their expertise and dedication exceeded all expectations.',
      author: 'John Davidson',
      role: 'CEO, TechCorp Industries',
      avatar: '👔'
    },
    {
      id: 2,
      text: 'The futuristic design and smooth performance of our new app is incredible. Zentak delivered beyond our wildest dreams.',
      author: 'Sarah Kim',
      role: 'Founder, FitLife Wellness',
      avatar: '💪'
    },
    {
      id: 3,
      text: 'The attention to detail in the glassmorphic design was remarkable. Our sales increased 150% within three months.',
      author: 'Michael Patel',
      role: 'Director, Urban Fashion Co.',
      avatar: '👗'
    },
    {
      id: 4,
      text: 'Working with Zentak was an absolute game-changer. They understood our vision perfectly and delivered exceptional results on time and within budget.',
      author: 'Emily Zhang',
      role: 'Product Lead, FinTech Innovations',
      avatar: '💼'
    },
    {
      id: 5,
      text: 'Outstanding technical expertise combined with amazing customer service. Zentak is the partner every startup needs.',
      author: 'David Wilson',
      role: 'Co-founder, StartupXYZ',
      avatar: '🚀'
    },
    {
      id: 6,
      text: "Their glassmorphic designs are not just beautiful, they're incredibly functional. User engagement metrics speak for themselves.",
      author: 'Lisa Anderson',
      role: 'CMO, Digital Marketing Agency',
      avatar: '📊'
    }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlay, setIsAutoPlay] = useState(true);

  // Auto-play carousel
  useEffect(() => {
    if (!isAutoPlay) return;
    
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    
    return () => clearInterval(interval);
  }, [isAutoPlay, testimonials.length]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
    setIsAutoPlay(false);
    setTimeout(() => setIsAutoPlay(true), 8000);
  };

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    setIsAutoPlay(false);
    setTimeout(() => setIsAutoPlay(true), 8000);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
    setIsAutoPlay(false);
    setTimeout(() => setIsAutoPlay(true), 8000);
  };

  return (
    <section id="testimonials">
      <div className="section-header">
        <h2 className="section-title">Client Testimonials</h2>
        <p className="section-subtitle">Real feedback from clients who love our work</p>
      </div>

      <div className="carousel-container fade-in">
        <div className="carousel-wrapper">
          <div className="carousel-track" style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
            {testimonials.map((testimonial) => (
              <div className="carousel-slide" key={testimonial.id}>
                <div className="testimonial-glass-carousel">
                  <div className="quote-icon">"</div>
                  <p className="testimonial-text">{testimonial.text}</p>
                  <div className="testimonial-author">
                    <div className="author-avatar-carousel">{testimonial.avatar}</div>
                    <div className="author-info">
                      <h5>{testimonial.author}</h5>
                      <p>{testimonial.role}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Navigation Arrows */}
        <button className="carousel-nav carousel-nav-prev" onClick={prevSlide} aria-label="Previous testimonial">
          ← 
        </button>
        <button className="carousel-nav carousel-nav-next" onClick={nextSlide} aria-label="Next testimonial">
          →
        </button>

        {/* Dots Navigation */}
        <div className="carousel-dots">
          {testimonials.map((_, index) => (
            <button
              key={index}
              className={`dot ${index === currentIndex ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
              aria-label={`Go to testimonial ${index + 1}`}
            />
          ))}
        </div>

        {/* Auto-play Indicator */}
        <div className="carousel-indicator" title="Auto-playing">
          {isAutoPlay ? (
            <span className="auto-play-badge">● Auto-playing</span>
          ) : (
            <span className="manual-badge">● Manual mode</span>
          )}
        </div>
      </div>
    </section>
  );
};

export default TestimonialCarousel;
